const bingematesPrivacy = {
    appName: 'BingeMates',
    lastUpdated: 'February 10, 2026',
    pageTitle: 'Privacy Policy for BingeMates',
    pageSubtitle: 'Browser Extension by Bogin Tech',
    introduction: {
        title: '1. Introduction',
        content:
            'BingeMates ("we," "our," or "us") provides a browser extension that enables synchronized video watching with real-time communication features.',
    },
    dataWeCollect: {
        title: '2. Data We Collect',
        description: 'We collect minimal data necessary for functionality:',
        userProvided: {
            title: '2.1 User-Provided Information',
            items: [
                'Display names (chosen by you, not real names)',
                'Room participation data',
            ],
        },
        automaticallyCollected: {
            title: '2.2 Automatically Collected Information',
            items: [
                'Video synchronization state (timestamp, play/pause status)',
                'Chat messages (within room sessions)',
                'Anonymous usage statistics (stored locally)',
            ],
        },
        dataWeDoNotCollect: {
            title: '2.3 Data We DO NOT Collect',
            items: [
                'Email addresses',
                'Real names',
                'Browsing history',
                'Video viewing content or preferences',
                'Location data',
                'Device identifiers',
            ],
        },
    },
    howWeUseData: {
        title: '3. How We Use Data',
        description: 'Data is used exclusively to:',
        items: [
            'Synchronize video playback across participants',
            'Enable chat and voice communication',
            'Maintain room sessions',
            'Improve extension functionality',
        ],
    },
    dataStorageAndRetention: {
        title: '4. Data Storage and Retention',
        items: [
            'Room data: Automatically deleted after 24 hours',
            'Chat messages: Deleted when room expires',
            'Usage analytics: Stored locally in browser, user-controlled',
            'No long-term data storage',
            'No user accounts or profiles',
        ],
    },
    dataSharing: {
        title: '5. Data Sharing',
        doNot: {
            description: 'We DO NOT:',
            items: [
                'Sell your data to third parties',
                'Share data with advertisers',
                'Use data for marketing purposes',
                'Track users across websites',
            ],
        },
        mayShare: {
            description: 'We MAY share data only when:',
            items: [
                'Required by law',
                'Necessary to protect our rights',
            ],
        },
    },
    thirdPartyServices: {
        title: '6. Third-Party Services',
        description:
            'These services have their own privacy policies. We ensure they comply with privacy standards.',
        services: [
            {
                name: 'Supabase',
                purpose: 'Database hosting — stores room and message data',
            },
            {
                name: 'PeerJS',
                purpose: 'Voice infrastructure — facilitates peer-to-peer connections',
            },
        ],
    },
    security: {
        title: '7. Security',
        description: 'We implement:',
        items: [
            'HTTPS encryption for all data transmission',
            'Database Row Level Security',
            'Automatic data deletion (24-hour room expiration)',
            'No permanent data storage',
        ],
    },
    yourRights: {
        title: '8. Your Rights',
        description: 'You have the right to:',
        items: [
            'Clear your local analytics data anytime',
            'Leave rooms and delete your participation',
            'Request information about your data',
            'Request data deletion',
        ],
    },
    childrensPrivacy: {
        title: "9. Children's Privacy",
        content:
            'BingeMates does not knowingly collect data from children under 13. No age verification or accounts are required.',
    },
    internationalUsers: {
        title: '10. International Users',
        content:
            'Data is processed in accordance with GDPR and international privacy standards. Data is stored in secure, encrypted databases.',
    },
    changesToPolicy: {
        title: '11. Changes to This Policy',
        content:
            'We may update this policy. Changes will be posted with a new "Last Updated" date. Continued use constitutes acceptance of changes.',
    },
    contactUs: {
        title: '12. Contact Us',
        content: 'Questions about this privacy policy?',
        email: 'privacy@bingemates.app',
    },
    gdprCompliance: {
        title: '13. GDPR Compliance',
        description: 'For EU users, we comply with GDPR by:',
        items: [
            'Collecting minimal necessary data',
            'Providing data deletion rights',
            'Obtaining implicit consent through usage',
            'Maintaining transparent privacy practices',
        ],
    },
    doNotTrack: {
        title: '14. Do Not Track',
        content:
            'We respect Do Not Track signals and do not track users across websites or sessions.',
    },
};

export default bingematesPrivacy;
